import React from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

function Return_Order_details_table({
  order,
  selectedItems,
  setSelectedItems,
  setError,
  setProductId,
  setShowReviewRating,
  showReviewRating,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val];
      }
    });
  };

  const handleOpenReview = async (productDetail) => {
    await setProductId(productDetail?.product_id);
    await setShowReviewRating(true);
  };
  return (
    <>
      <section className="Order_details_table Cart_Products_card d-none d-lg-block">
        <div className="table-responsive">
          <Table className="theme_bg_ternary_colour">
            <tbody>
              {/* {order?.Return_Order_Details?.map((val) => ( */}
              <tr>
                {/* <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedItems?.some((item) => item.id === val.id)}
                      onChange={() => handleCheckboxChange(val)}
                    />
                  </td> */}
                <td>
                  <div className="row">
                    <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={order?.Product_Order_Detail?.Product?.image}
                          alt={"Product_img"}
                        />
                      </div>
                    </div>
                    <div className=" col-xl-10 col-lg-9 col-md-9 col-9">
                      <div className="info_text_holder">
                        <div>
                          <h4>{order?.Product_Order_Detail?.Product?.name}</h4>

                          <div className="mt-1">
                            {order?.Product_Order_Detail?.Product_Variant
                              ?.name && (
                              <p className="mb-1">
                                Polish :{" "}
                                {
                                  order?.Product_Order_Detail?.Product_Variant
                                    ?.name
                                }
                              </p>
                            )}

                            {order?.Product_Order_Detail?.Double_Variant
                              ?.name && (
                              <p className="mb-1">
                                Colour :{" "}
                                {
                                  order?.Product_Order_Detail?.Double_Variant
                                    ?.name
                                }
                              </p>
                            )}

                            {order?.Product_Order_Detail?.Triple_Variant
                              ?.name && (
                              <p className="mb-1">
                                Size :{" "}
                                {
                                  order?.Product_Order_Detail?.Triple_Variant
                                    ?.name
                                }
                              </p>
                            )}
                          </div>
                          <div className="mt-3">
                            {order?.Return_Reason?.name && (
                              <p className="mb-1">
                                Return Reason : {order.Return_Reason.name}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {order?.Product_Order_Detail?.Product?.Rating_Reviews ===
                      null && (
                      <div className="mt-2">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleOpenReview(order)}
                        >
                          Review & Rating
                        </button>
                      </div>
                    )}
                  </div>
                </td>

                <td>
                  <div className="new_price_holder">
                    <p className="price_inner_text">
                      <span className="right_label">Price : </span>₹
                      {order?.Product_Order_Detail?.selling_price}
                    </p>

                    <p className="price_inner_text">
                      <span className="right_label">Order Qty : </span>
                      {order?.Product_Order_Detail?.quantity}
                    </p>

                    {/* <p className="price_inner_text">
                        <span className="right_label">Total Price : </span>₹
                        {order?.Product_Order_Detail?.quantity *
                          order?.Product_Order_Detail?.selling_price}
                      </p> */}

                    <p className="price_inner_text">
                      <span className="right_label">Total Price : </span>₹{" "}
                      {Number(
                        order?.Product_Order_Detail?.offer_discount || 0,
                      ) > 0
                        ? Number(
                            order?.Product_Order_Detail?.total_amount || 0,
                          ).toFixed(2)
                        : (
                            Number(order?.Product_Order_Detail?.quantity || 0) *
                            Number(
                              order?.Product_Order_Detail?.selling_price || 0,
                            )
                          ).toFixed(2)}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </section>

      <div className="d-block d-lg-none mobile_view_holder">
        {/* {order?.Return_Order_Details?.map((val) => ( */}
        <div className="mobile_product_card" key={order?.id}>
          <Link
            to={`/product-details/${order?.Product_Order_Detail?.Product?.id}`}
            className="text-decoration-none text-dark"
          >
            <div className="row justify-content-center">
              <div className="col-md-6 col-8 mb-3">
                <div className="img_holder">
                  <img
                    className="Product_img"
                    src={order?.Product_Order_Detail?.Product?.image}
                    alt={order?.Product_Order_Detail?.Product?.name}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="descn_holder">
                  <div className="left_div">
                    <h6 className="product_name mb-2">
                      {order?.Product_Order_Detail?.Product?.name}
                    </h6>

                    {order?.Product_Order_Detail?.Product_Variant?.name && (
                      <p className="mb-1">
                        <strong>Polish :</strong>{" "}
                        {order?.Product_Order_Detail?.Product_Variant?.name}
                      </p>
                    )}

                    {order?.Product_Order_Detail?.Double_Variant?.name && (
                      <p className="mb-1">
                        <strong>Colour :</strong>{" "}
                        {order?.Product_Order_Detail?.Double_Variant?.name}
                      </p>
                    )}

                    {order?.Product_Order_Detail?.Triple_Variant?.name && (
                      <p className="mb-1">
                        <strong>Size :</strong>{" "}
                        {order?.Product_Order_Detail?.Triple_Variant?.name}
                      </p>
                    )}
                  </div>

                  <div className="price_details">
                    <p className="mb-1">
                      <strong>Price :</strong> ₹
                      {order?.Product_Order_Detail?.selling_price}
                    </p>

                    <p className="mb-1">
                      <strong>Order Qty :</strong>{" "}
                      {order?.Product_Order_Detail?.quantity}
                    </p>

                    {/* <p className="mb-0">
                      <strong>Total Price :</strong> ₹
                      {order?.Product_Order_Detail?.quantity *
                        order?.Product_Order_Detail?.selling_price}
                    </p> */}

                    <p className="mb-0">
                      <strong>Total Price :</strong> ₹
                      {Number(
                        order?.Product_Order_Detail?.offer_discount || 0,
                      ) > 0
                        ? Number(
                            order?.Product_Order_Detail?.total_amount || 0,
                          ).toFixed(2)
                        : (
                            Number(order?.Product_Order_Detail?.quantity || 0) *
                            Number(
                              order?.Product_Order_Detail?.selling_price || 0,
                            )
                          ).toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>

          {order?.Product_Order_Detail?.Product?.Rating_Reviews === null && (
            <div className="mt-3">
              <button
                className="btn btn-success btn-sm w-100"
                onClick={() => handleOpenReview(order)}
              >
                Review & Rating
              </button>
            </div>
          )}
        </div>
        {/* ))} */}
      </div>
    </>
  );
}

export default Return_Order_details_table;
